import ApplicationsRouter from '@/components/pages/application/index.vue';
import MailTemplateList from '@/components/pages/mails/templates/List.vue';
import TemplateEdit from '@/components/pages/mails/templates/Edit.vue';
import TemplateConfirm from '@/components/pages/mails/templates/Confirm.vue';

export default {
  path: '/mail_templates',
  component: ApplicationsRouter,
  children: [
    {
      path: '',
      name: 'MailTemplates',
      component: MailTemplateList,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: 'add',
      name: 'MailTemplateAdd',
      component: TemplateEdit,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: 'add/confirm',
      name: 'MailTemplateConfirm',
      component: TemplateConfirm,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: ':mailTemplateId/edit',
      name: 'MailTemplateEdit',
      component: TemplateEdit,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: ':mailTemplateId/edit/confirm',
      name: 'MailTemplateEditConfirm',
      component: TemplateConfirm,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: ':mailTemplateId/copy',
      name: 'MailTemplateCopy',
      component: TemplateEdit,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: ':mailTemplateId/copy/confirm',
      name: 'MailTemplateCopyConfirm',
      component: TemplateConfirm,
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
